module.exports = __webpack_public_path__ + "img/negative.e15cbf3a.svg";